import Repository from "./repository";

const resource = "Enum";

export default {
  async getDisconnectionType() {
    let endpoint = `${resource}/DisconnectionType`;
    let response = await Repository.get(endpoint);
    return response;
  },
  async getOperatorStatus() {
    let endpoint = `${resource}/OperatorStatus`;
    let response = await Repository.get(endpoint);
    return response;
  }
};